'use client'
import React from 'react'
import Link from 'next/link'
import { LFButton, LFButtonColor, LFButtonType } from '@components/LFButton'
import { useTranslation } from 'react-i18next'

const NotFound: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col items-center justify-center gap-y-16">
      <h1 className="mt-24 text-9xl text-primary-300">{t('oops')}</h1>
      <p className="text-5xl">{t('error404')}</p>
      <img src="/static/assets/404.svg" />
      <Link href={'/overview'}>
        <LFButton type={LFButtonType.PRIMARY} color={LFButtonColor.MAIN}>
          {t('goBack')}
        </LFButton>
      </Link>
    </div>
  )
}

export default NotFound
